import React from "react";
import {Card, Image} from "@nextui-org/react";
import brandLogo from '../src/assets/images/icon128.png'

const AuthenticationSuccessPage = () => {
    return (
        <div className="container mx-auto h-screen py-6 rounded-3xl max-w-[750px] flex-col flex items-center justify-center ">
            <Card className="p-6 border-1 flex flex-col gap-6 items-center shadow-none">
                <Image

                    width={64}
                    src={brandLogo}
                    alt="Brand Logo "
                />
                <p className="mb-4 text-5xl text-center">
                    Authenticated Successfully Open Popup!
                </p>
                <p className="mb-8 text-2xl text-center">
                    You can now open the popup and start composing your emails with ease.
                    Open Popup and Start Composing
                </p>
            </Card>
        </div>
    );
};

export default AuthenticationSuccessPage;
